import React, { useCallback } from 'react';
import { GroupSearchResult } from 'graphql/types';
import { GroupSelectCount } from '../constant';
import { useGroupSelectLabel } from '../hooks/useGroupSelectType';
import { GroupSelect } from '../GroupSelect';
import { GroupSelectDropdownProp } from '../types';
import { useSelectSearchAction } from './hooks/useSelectSearchAction';

const emptyData: GroupSearchResult[] = [];

export const ServiceCentersSelect: React.FC<GroupSelectDropdownProp> = ({
  groupType,
  rowID,
  defaultValues,
  classes
}: GroupSelectDropdownProp) => {
  const {
    searchHandler,
    data: { serviceCenters: serviceCentersData },
    loading: { serviceCenters: serviceCentersLoading }
  } = useGroupSelectLabel();

  const serviceCenters =
    serviceCentersData?.groupsSearch?.serviceCenters.items || emptyData;
  const hasMore = serviceCenters.length === GroupSelectCount;

  const { handleSearch } = useSelectSearchAction(searchHandler);

  const onOpen = useCallback(() => {
    handleSearch(groupType, null);
  }, [groupType, handleSearch]);

  return (
    <GroupSelect
      groupType={groupType}
      onOpen={onOpen}
      handleSearch={handleSearch}
      options={serviceCenters}
      hasMore={hasMore}
      loading={serviceCentersLoading}
      rowID={rowID}
      defaultValues={defaultValues}
      classes={classes}
    />
  );
};
